import React, { useState, useEffect, useRef } from 'react';
import MaterialTable from 'material-table';
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import { colors } from '../components/Theme/WebTheme';
import { downloadCsv } from '../common/sharedFunctions';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/min/moment-with-locales';
import { SECONDORY_COLOR } from "../common/sharedFunctions";
export default function Users() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector(state => state.settingsdata.settings);
  const navigate = useNavigate();
  const {
    deleteUser,
    fetchUsersOnce
  } = api;
  const [data, setData] = useState([]);
  const [sortedData, SetSortedData] = useState([]);
  const staticusers = useSelector(state => state.usersdata.staticusers);
  const dispatch = useDispatch();
  const loaded = useRef(false);

  useEffect(() => {
    dispatch(fetchUsersOnce());
  }, [dispatch, fetchUsersOnce]);

  useEffect(() => {
    if (staticusers) {
      setData(staticusers.filter(user => user.usertype === 'admin'));
    } else {
      setData([]);
    }
    loaded.current = true;
  }, [staticusers]);

  useEffect(() => {
    if (sortedData) {
      SetSortedData(data.sort((a, b) => (moment(b.createdAt) - moment(a.createdAt))))
    }
  }, [data, sortedData])

  const columns = [
    { title: t('first_name'), field: 'firstName', initialEditValue: '' },
    { title: t('last_name'), field: 'lastName', initialEditValue: '' },
    { title: t('mobile'), field: 'mobile', editable: 'onAdd', render: rowData => settings.AllowCriticalEditsAdmin ? rowData.mobile : t("hidden_demo") },
    { title: t('email'), field: 'email', editable: 'onAdd', render: rowData => settings.AllowCriticalEditsAdmin ? rowData.email : t("hidden_demo"), headerStyle: { textAlign: 'center' } },
    {
      title: t("profile_image"),
      field: "profile_image",
      render: (rowData) => (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          {rowData.profile_image ? (
            <img
              alt="Profile"
              src={rowData.profile_image}
              style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }}
            />
          ) : (
            <AccountCircleIcon sx={{ fontSize: 40 }} />
          )}
        </div>
      ),
      editable: "never",


    },
  ];

  const [selectedRow, setSelectedRow] = useState(null);
  return (
    !loaded.current ? <CircularLoading /> :
      <div>
        
        <MaterialTable
          title={t('alladmins_title')}
          columns={columns}
          style={{
            direction: isRTL === "rtl" ? "rtl" : "ltr",
            borderRadius: "0 0 20px 20px",
            boxShadow: "var(--shadow)",
            border: "none",
            padding: "0",
            backgroundColor: "var(--bg-card)",
            backdropFilter: "blur(12px)",
            borderLeft: "var(--card-border)",
            borderRight: "var(--card-border)",
            borderBottom: "var(--card-border)",
            overflow: "hidden"
          }}
          data={sortedData}
          onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
          options={{
            pageSize: 10,
            pageSizeOptions: [10, 15, 20],
            exportCsv: (columns, data) => {
              let hArray = [];
              const headerRow = columns.map(col => {
                if (typeof col.title === 'object') {
                  return col.title.props.text;
                }
                hArray.push(col.field);
                return col.title;
              });
              const dataRows = data.map(({ tableData, ...row }) => {
                row.createdAt = new Date(row.createdAt).toLocaleDateString() + ' ' + new Date(row.createdAt).toLocaleTimeString()
                let dArr = [];
                for (let i = 0; i < hArray.length; i++) {
                  dArr.push(row[hArray[i]]);
                }
                return Object.values(dArr);
              })
              const { exportDelimiter } = ",";
              const delimiter = exportDelimiter ? exportDelimiter : ",";
              const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
              const csvFileName = 'download.csv';
              downloadCsv(csvContent, csvFileName);
            },
            exportButton: {
              csv: settings.AllowCriticalEditsAdmin,
              pdf: false,
            },
            maxColumnSort: "all_columns",
            rowStyle: (rowData) => ({
              backgroundColor: selectedRow === rowData.tableData.id ? "var(--table-row-selected)" : "var(--table-row-bg)",
              borderBottom: "var(--table-border)",
              fontSize: "14px",
              color: "var(--text-main)"
            }),
            editable: {
              backgroundColor: colors.Header_Text,
              fontSize: "0.8em",
              fontWeight: "bold ",
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            },
            headerStyle: {
              position: "sticky",
              top: "0px",
              background: "var(--table-header-bg)",
              color: "var(--text-light)",
              textAlign: "center",
              fontWeight: "700",
              fontFamily: 'Inter, sans-serif',
              border: "none",
              height: "56px",
              borderBottom: "var(--card-border)"
            },
            cellStyle: {
              borderBottom: "var(--table-border)",
              textAlign: "center",
              padding: "14px",
              color: "var(--text-main)"
            },
            actionsColumnIndex: -1,
          }}
          localization={{
            body: {
              addTooltip: (t('add')),
              deleteTooltip: (t('delete')),
              editTooltip: (t('edit')),
              emptyDataSourceMessage: (
                (t('blank_message'))
              ),
              editRow: {
                deleteText: (t('delete_message')),
                cancelTooltip: (t('cancel')),
                saveTooltip: (t('save'))
              },
            },
            toolbar: {
              searchPlaceholder: (t('search')),
              exportTitle: (t('export')),
            },
            header: {
              actions: (t('actions'))
            },
            pagination: {
              labelDisplayedRows: ('{from}-{to} ' + (t('of')) + ' {count}'),
              firstTooltip: (t('first_page_tooltip')),
              previousTooltip: (t('previous_page_tooltip')),
              nextTooltip: (t('next_page_tooltip')),
              lastTooltip: (t('last_page_tooltip'))
            },
          }}
          editable={{
            onRowDelete: oldData =>
              settings.AllowCriticalEditsAdmin ?
                new Promise(resolve => {
                  setTimeout(() => {
                    resolve();
                    if (oldData.id === 'admin0001') {
                      alert(t('first_admin_deleted'));
                    } else {
                      dispatch(deleteUser(oldData.id));
                      dispatch(fetchUsersOnce());
                    }
                  }, 600);
                })
                :
                new Promise(resolve => {
                  setTimeout(() => {
                    resolve();
                    alert(t('demo_mode'));
                  }, 600);
                })
            ,
          }}


          actions={[
            {
              icon: 'add',
              tooltip: t("add_admin"),
              isFreeAction: true,
              onClick: (event) => navigate("/users/edituser/admin"),

            },
            (rowData) => ({
              tooltip: t("edit"),
              icon: () => (
                <EditIcon fontSize="small" style={{ color: "var(--text-main)" }} />
              ),
              onClick: (event, rowData) => navigate(`/users/edituser/admin/${rowData.id}`)
            }),
          ]}
        />
      </div>
  );
}
